import { success, error } from './../common/helpers/constanHelpers';
import { createSimpleAction } from './actionCreator';
import {
  GET_USER_DETAILS,
  UPDATE_USER_BASIC_META,
  CLEAR_USER,
  UPLOAD_PROFILE_PICTURE,
  SET_PERMISSIONS,
  DELETE_USER,
  UPDATE_USER_DATA,
  FETCH_BASIC_USERS,
  CREATE_USER
} from '../store/constants';

const doGetUserDetails = payload => ({
  type: GET_USER_DETAILS,
  payload,
});

const doGetUserDetailsSuccess = payload => ({
  type: success(GET_USER_DETAILS),
  payload,
});

const doGetUserDetailsError = payload => ({
  type: error(GET_USER_DETAILS),
  payload,
});

const doUpdateBasicUserMeta = payload => ({
  type: UPDATE_USER_BASIC_META,
  payload,
});

const doUpdateBasicUserMetaSuccess = payload => ({
  type: success(UPDATE_USER_BASIC_META),
  payload,
});

const doUpdateBasicUserMetaError = payload => ({
  type: error(UPDATE_USER_BASIC_META),
  payload,
});

const doUploadProfilePictureSuccess = payload => ({
  type: success(UPLOAD_PROFILE_PICTURE),
  payload,
});

const doUploadProfilePictureError = payload => ({
  type: error(UPLOAD_PROFILE_PICTURE),
  payload,
});

const doClearUser = () => ({
  type: CLEAR_USER,
});

const doSetPermissions = createSimpleAction(SET_PERMISSIONS);
const doSetPermissionsSuccess = createSimpleAction(success(SET_PERMISSIONS));
const doSetPermissionsError = createSimpleAction(error(SET_PERMISSIONS));

// NEW: Delete user actions
const doDeleteUser = payload => ({
  type: DELETE_USER,
  payload,
});

const doDeleteUserSuccess = payload => ({
  type: success(DELETE_USER),
  payload,
});

const doDeleteUserError = payload => ({
  type: error(DELETE_USER),
  payload,
});

// NEW: Update full user data actions
const doUpdateUserData = payload => ({
  type: UPDATE_USER_DATA,
  payload,
});

const doUpdateUserDataSuccess = payload => ({
  type: success(UPDATE_USER_DATA),
  payload,
});

const doUpdateUserDataError = payload => ({
  type: error(UPDATE_USER_DATA),
  payload,
});

// NEW: Fetch basic users for dropdowns
const doFetchBasicUsers = () => ({
  type: FETCH_BASIC_USERS,
});

const doFetchBasicUsersSuccess = payload => ({
  type: success(FETCH_BASIC_USERS),
  payload,
});

const doFetchBasicUsersError = payload => ({
  type: error(FETCH_BASIC_USERS),
  payload,
});

const doCreateUser = (formData) => ({
  type: CREATE_USER,
  payload: formData,
});

const doCreateUserSuccess = (data) => ({
  type: success(CREATE_USER),
  payload: data,
});

const doCreateUserError = (err) => ({
  type: error(CREATE_USER),
  payload: err,
});

export {
  doGetUserDetails,
  doGetUserDetailsSuccess,
  doGetUserDetailsError,
  doUpdateBasicUserMeta,
  doUpdateBasicUserMetaSuccess,
  doUpdateBasicUserMetaError,
  doUploadProfilePictureSuccess,
  doUploadProfilePictureError,
  doClearUser,
  doSetPermissions,
  doSetPermissionsSuccess,
  doSetPermissionsError,
  doDeleteUser,
  doDeleteUserSuccess,
  doDeleteUserError,
  doUpdateUserData,
  doUpdateUserDataSuccess,
  doUpdateUserDataError,
  doFetchBasicUsers,
  doFetchBasicUsersSuccess,
  doFetchBasicUsersError,
  doCreateUser,
  doCreateUserSuccess,
  doCreateUserError
};